// 前世の酒呑童子で、移動・攻撃・幟・術を体験する報酬なしの戦い（陣地・龍脈は現代の初戦でユズハが教える）。
// 3手番の一本道：城への道の足軽 → 幟を立てて侍大将 → 紅蓮斬で落城。毎手番に倒す相手がいて、手番終了を待たない。
// 奥義と番人の結界は扱わない。人間の軍は持ち場から動かない（hold）。
import type { BattleLoadout } from '../types';

export const PROLOGUE = {
  /** 敵本陣のHP（1章7面の本陣に対する倍率）。幟で強めた術で落とせる強さ */
  coreHp: 3.3,
  /** 盤の上の絵と名前（data/enemies の酒呑童子） */
  heroEnemyId: 'h00',
  /** 始まりの妖力の撃破ポイント（壱） */
  surgePoints: 0,
  /** 見た目（絵・メダリオン・エフェクト・カットイン）と技の名前 */
  look: 'shuten',
  skillName: '紅蓮斬',
  ougiName: '百鬼覇道',
  /**
   * 人間の軍（列・行）。role＝案内で倒す相手（ashigaru → general）。無いものは景色の雑兵。
   * hp は neutralStats に掛ける倍率（案内の相手は酒呑の一撃で倒れる強さ）
   */
  foes: [
    { at: [4, 3], enemyId: 'h01', tier: 'small', role: 'ashigaru', hp: 1 },
    { at: [3, 3], enemyId: 'h09', tier: 'elite', role: 'general', hp: 1 },
    { at: [4, 2], enemyId: 'h02', tier: 'small', hp: 1 },
    { at: [5, 3], enemyId: 'h03', tier: 'small', hp: 1 },
    { at: [0, 3], enemyId: 'h02', tier: 'small', hp: 1 },
    { at: [5, 5], enemyId: 'h01', tier: 'small', hp: 1 },
    { at: [0, 6], enemyId: 'h03', tier: 'small', hp: 1 },
  ] as { at: [number, number]; enemyId: string; tier: 'small' | 'medium' | 'elite'; role?: 'ashigaru' | 'general'; hp: number }[],
  /** 案内で止まるマス（列・行）。ashigaru：城への道の上（4マス先）、general：侍大将と城の両方の隣 */
  stand: { ashigaru: [3, 4], general: [2, 2] } as Record<'ashigaru' | 'general', [number, number]>,
};

/** 操作する酒呑童子。性能はスズネ（大槌）を元に強くしたもの。術「紅蓮斬」・奥義「百鬼覇道」は名前と見た目だけ酒呑童子のもの（効果はスズネの破城・鬼哭破城と同じ） */
export function prologueLoadout(): BattleLoadout {
  return {
    charId: 'suzune',
    level: 99,
    stats: { hp: 900, atk: 120, def: 30, agi: 140, move: 0, range: 1 },
    skill: { power: 1.3, cdDelta: -1, splashBonus: 0.3 },
    // 建てられるのは幟（隣のマスの味方の与ダメ増）を1本だけ。陣材はちょうど1本分
    build: { unlocked: ['nobori'], levels: {}, maxCount: 1, perTurn: 1, costMult: 1, hpMult: 1, powerMult: 1, range: 1 },
    materials: { start: 4, incomeBonus: 0 },
    potions: { count: 2, heal: 0.5 },
    items: [{ id: 'heal', count: 2 }],
    diceMin: 4,
    respawnDelta: -1,
    territoryBonus: 0.1,
    mult: { core: 1.3, boss: 1.4, neutral: 1.5, taken: 0.6 },
    lifesteal: 0.1,
    flags: [],
  };
}
